export default __webpack_public_path__ + "static/media/fontMulish700_latin.53421642.woff2";